import React from 'react';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

interface Props {
  name: string;
  size?: AvatarSize | number;
  ring?: string;
  className?: string;
}

const SIZE_PX: Record<AvatarSize, number> = {
  sm: 32,
  md: 44,
  lg: 64,
  xl: 96,
};

const PALETTES: Array<{ bg: string; fg: string }> = [
  { bg: '#E7DFC8', fg: '#0B3F12' },
  { bg: '#D4E4D6', fg: '#0B3F12' },
  { bg: '#F2D680', fg: '#5C3F02' },
  { bg: '#E8C9B7', fg: '#6B2818' },
  { bg: '#C8D6E4', fg: '#1F3A5F' },
  { bg: '#D9CCE0', fg: '#3F2360' },
  { bg: '#EBD7D7', fg: '#7A2A2A' },
  { bg: '#D7E5DC', fg: '#1A4F35' },
];

export function avatarTint(name: string): { bg: string; fg: string } {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTES[h % PALETTES.length];
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ name, size = 'md', ring, className }: Props) {
  const px = typeof size === 'number' ? size : SIZE_PX[size];
  const tint = avatarTint(name);
  const ringShadow = ring ? `0 0 0 3px ${ring}, 0 0 0 5px #FBF7EC` : 'inset 0 0 0 1px rgba(0,0,0,0.05)';
  return (
    <div
      aria-hidden="true"
      className={['inline-flex items-center justify-center rounded-full font-display font-bold shrink-0', className || ''].join(' ').trim()}
      style={{
        width: px,
        height: px,
        background: tint.bg,
        color: tint.fg,
        fontSize: Math.round(px * 0.38),
        letterSpacing: '-0.02em',
        boxShadow: ringShadow,
      }}
    >
      {initialsOf(name)}
    </div>
  );
}
